import { ScrollModel } from "../Components/Models/ScrollController/ScrollModel";


class MainScroll extends ScrollModel {

}

export { MainScroll }